import { render, staticRenderFns } from "./APIKey.vue?vue&type=template&id=2ab13d22&scoped=true&"
import script from "./APIKey.vue?vue&type=script&lang=js&"
export * from "./APIKey.vue?vue&type=script&lang=js&"
import style0 from "./APIKey.vue?vue&type=style&index=0&id=2ab13d22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab13d22",
  null
  
)

export default component.exports